<template>
	<div>
		<div class="cont">
			<Breadcrumb :pathList='pathList'></Breadcrumb>
			<div v-if="infoList.length!=0" class="infoItem pointer" v-for="(item,index) in infoList" @click="toPage('/messageDetail?id='+item.uuid)">
				<div class="flex flex-b">
					<div class="flex">
						<img :src="item.icon" alt="" style="width: 24px;height: 24px;" />
						<div class="tit" :class="item.is_read==1?'point':''">{{item.tit}}</div>
					</div>
					<div class="time">{{item.create_time}}</div>
				</div>
				<div class="det">{{item.content}}</div>
				<div class="flex flex-b" style="margin-top: 10px;">
					<div class="t">查看详情</div>
					<img src="../../assets/images/icon/iarrow.png" style="width: 13px;height: 13px;" alt="" />
				</div>
			</div>
			<div class="flex flex-c flex-column-item flex-c-c nodata hotbg" v-else>
				<img src="../../assets/images/mine/ico5.png" style="width: 38px;height: auto;margin-bottom: 10px;" />
				暂无内容
			</div>
		</div>
		<toTop></toTop>
		<Footer></Footer>
	</div>
</template>

<script>
	import {
		getMyMessageList
	} from '@/api/mine';
	import Breadcrumb from '../../components/Breadcrumb.vue'
	import toTop from '../../components/toTop.vue'
	import Footer from '../../components/Footer.vue'
	export default{
		data() {
			return{
				pathList:[
					{title:'我的',path:'/mine'},
					{title:'消息通知',path:''}
				],
				infoList:[],
				page_index:1,
				page_size:10,
				count:0
			}
		},
		components:{
			Breadcrumb,toTop,Footer
		},
		mounted() {
			this.getMyMessageList()
		},
		methods:{
			async getMyMessageList(){
				const {
					status,
					data
				} = await getMyMessageList({
					page_index:this.page_index,
					page_size:this.page_size
				})
				this.count = data.result.total
				let arrs = data.result.data
				arrs.forEach(item=>{
					let obj = {
						...item,
						icon:'',
						tit:''
					}
					if(item.type==1){
						//系统通知
						obj.icon = require('../../assets/images/mine/icInfo1.png')
						obj.tit='系统通知'
					}
					if(item.type==2){
						//评论审核通知
						obj.icon = require('../../assets/images/mine/icInfo2.png')
						obj.tit='评论审核通知'
					}
					if(item.type==3){
						//报名成功通知
						obj.icon = require('../../assets/images/mine/icInfo3.png')
						obj.tit='报名成功通知'
					}
					if(item.type==4){
						//课程通知
						obj.icon = require('../../assets/images/mine/icInfo4.png')
						obj.tit='课程通知'
					}
					if(item.type==5){
						//会员通知
						obj.icon = require('../../assets/images/mine/icInfo5.png')
						obj.tit='会员通知'
					}
					this.infoList.push(obj)
				})
			},
			toPage(path) {
				this.$router.push({
					path: path
				})
			},
		}
	}
</script>

<style lang="less" scoped>
	.cont{
		padding: 30px 133px 0;
		min-height: 100vh;
		.infoItem{
			background: #FFFFFF;
			box-shadow: 0px 3px 13px 0px rgba(0,0,0,0.06);
			border-radius: 13px 13px 13px 13px;
			padding: 20px;
			margin: 20px 0;
			.tit{
				margin-left: 10px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 500;
				font-size: 16px;
				color: #000000;
			}
			.point{
				position: relative;
				&::after{
					position: absolute;
					content: '';
					right: -8px;
					top: 0;
					width: 9px;
					height: 9px;
					background: #FC5F5F;
					border: 1px solid #FFFFFF;
					border-radius: 50%;
				}
			}
			.time{
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #999999;
			}
			.det{
				margin-top: 10px;
				padding-top: 10px;
				border-top: 1px solid #EEEEEE;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 18px;
				color: #000000;
			}
			.t{
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #666666;
			}
		}
	}
	
	.hotbg {
		width: 100%;
		height: 378px;
		padding: 36px 133px 48px 133px;
		border-radius: 0 0 30px 30px;
	
	}
</style>